<!-- components/ArrowUp.svelte -->
<script>

</script>

<a 
  href={'#'} 
  class="back-to-top d-flex align-items-center justify-content-center active"   
  >
  <i class="bi bi-arrow-up-short"></i>
</a>